var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconPhotos = function SvgIconPhotos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 490 490"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 167.85v216.2c0 33 26.8 59.8 59.8 59.8h370.4c33 0 59.8-26.8 59.8-59.8v-216.2c0-31.4-25.5-56.9-56.9-56.9h-79.6l-1.9-8.3c-7.7-33.3-37-56.5-71.2-56.5h-70.9c-34.1 0-63.4 23.2-71.2 56.5l-1.9 8.3H56.9c-31.4 0-56.9 25.6-56.9 56.9zm146.2-32.4c5.7 0 10.6-3.9 11.9-9.5l4.1-17.8c5.2-22.1 24.6-37.5 47.3-37.5h70.9c22.7 0 42.1 15.4 47.3 37.5l4.1 17.8c1.3 5.5 6.2 9.5 11.9 9.5H433c17.9 0 32.4 14.5 32.4 32.4v216.2c0 19.5-15.8 35.3-35.3 35.3H59.8c-19.5 0-35.3-15.8-35.3-35.3v-216.2c0-17.9 14.5-32.4 32.4-32.4h89.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M245 380.95c56.7 0 102.9-46.2 102.9-102.9s-46.2-102.9-102.9-102.9-102.9 46.1-102.9 102.9 46.2 102.9 102.9 102.9zm0-181.3c43.2 0 78.4 35.2 78.4 78.4s-35.2 78.4-78.4 78.4-78.4-35.2-78.4-78.4 35.2-78.4 78.4-78.4z"
  })));
};

export default __webpack_public_path__ + "static/media/icon-photos.11c75aca.svg";
export { SvgIconPhotos as ReactComponent };